import React, { useState } from 'react';
import { CameraIcon, RadioIcon, SearchIcon, ListIcon, WifiOffIcon, RefreshCwIcon, CheckCircleIcon, XCircleIcon, ShieldAlertIcon, PlusIcon, MapPinIcon, FileTextIcon, AlertTriangleIcon, UserIcon, ShipIcon, CalendarIcon, NavigationIcon } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
export function MobileFieldOfficer() {
  const [view, setView] = useState<'home' | 'scan' | 'result' | 'compliance' | 'report-case'>('home');
  const [isOnline, setIsOnline] = useState(true);
  const [scanResult, setScanResult] = useState<'valid' | 'invalid' | null>(null);
  // Compliance State
  const [complianceForm, setComplianceForm] = useState({
    offenderName: '',
    offenseType: '',
    description: '',
    latitude: '21.9497',
    longitude: '89.1833',
    severity: 'Medium'
  });
  const activeTrips = [{
    name: 'Rahim Uddin',
    permitId: 'PER-2024-001',
    range: 'Chandpai Range',
    station: 'Karamjal Station',
    entryTime: '06:00 AM'
  }, {
    name: 'Karim Sheikh',
    permitId: 'PER-2024-002',
    range: 'Sarankhola Range',
    station: 'Sharankhola Station',
    entryTime: '05:30 AM'
  }, {
    name: 'Fatema Begum',
    permitId: 'PER-2024-003',
    range: 'Khulna Range',
    station: 'Nalian Station',
    entryTime: '07:15 AM'
  }];
  const recentCases = [{
    id: 'CASE-001',
    type: 'Illegal Entry',
    status: 'open',
    date: '2024-03-28'
  }, {
    id: 'CASE-002',
    type: 'Poaching',
    status: 'resolved',
    date: '2024-03-25'
  }];
  const handleScan = (type: 'qr' | 'rfid') => {
    setView('scan');
    setTimeout(() => {
      setScanResult(Math.random() > 0.3 ? 'valid' : 'invalid');
      setView('result');
    }, 2000);
  };
  const handleReportCase = () => {
    alert('Case reported successfully!');
    setView('compliance');
    setComplianceForm({
      offenderName: '',
      offenseType: '',
      description: '',
      latitude: '21.9497',
      longitude: '89.1833',
      severity: 'Medium'
    });
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-1593" data-mp="28j1ck6up6p79">
      {/* Mobile Frame */}
      <div className="w-full max-w-sm bg-white rounded-[3rem] shadow-2xl overflow-hidden flex flex-col h-[800px] border-[8px] border-gray-900 relative" data-id="element-1594" data-mp="2najr007wsboi">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-6 bg-gray-900 rounded-b-2xl z-20" data-id="element-1595" data-mp="1ukl0e0e2g6hq"></div>

        {/* Status Bar */}
        <div className="bg-[#1B5E20] pt-8 pb-4 px-6 flex-shrink-0" data-id="element-1596" data-mp="1pn1gokyln1ie">
          <div className="flex items-center justify-between text-white" data-id="element-1597" data-mp="23m15bsm43gek">
            <div className="flex items-center gap-2" data-id="element-1598" data-mp="1zhtftt7txwfa">
              <div className="font-bold text-lg tracking-tight" data-id="element-1599" data-mp="3ezmw1i7mdq27">
                Forest Field App
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-1600" data-mp="3ayt7cmmcs789">
              <div className="flex items-center gap-1.5 bg-white/10 px-2 py-1 rounded-full" data-id="element-1601" data-mp="3b0e2adckxs6n">
                <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`} data-id="element-1602" data-mp="3ijne0d8k62yv"></div>
                <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1603" data-mp="38kg1fs9necct">
                  {isOnline ? 'Online' : 'Offline'}
                </span>
              </div>
              <button onClick={() => setIsOnline(!isOnline)} className="p-1.5 hover:bg-white/20 rounded-full transition-colors" data-id="element-1604" data-mp="524ik7nvvtog">
                <RefreshCwIcon size={16} data-id="element-1605" data-mp="a3lle8pxhq7o" />
              </button>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto bg-gray-50/50" data-id="element-1606" data-mp="b63tcijn3nb">
          {view === 'home' && <div className="p-6 space-y-6" data-id="element-1607" data-mp="o1a6nhnwqzd9">
              <div className="space-y-1" data-id="element-1608" data-mp="nzfiluhcar4y">
                <h2 className="text-2xl font-black text-gray-900" data-id="element-1609" data-mp="sss1rp3925qb">
                  Field Verification
                </h2>
                <p className="text-sm text-gray-500" data-id="element-1610" data-mp="31a2uroqeih1c">
                  Select a scanning method to verify permits
                </p>
              </div>

              {/* Action Cards */}
              <div className="grid gap-4" data-id="element-1611" data-mp="2rc6l71d43u5c">
                <button onClick={() => handleScan('qr')} className="group w-full bg-white border border-gray-100 rounded-[2rem] p-6 flex items-center gap-5 hover:border-green-200 hover:bg-green-50/30 transition-all shadow-sm active:scale-[0.98]" data-id="element-1612" data-mp="2rcyjwl20a7zu">
                  <div className="w-16 h-16 bg-green-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-green-600/20 group-hover:scale-110 transition-transform" data-id="element-1613" data-mp="3f32bfu1x6hah">
                    <CameraIcon size={32} data-id="element-1614" data-mp="358txcbdmyqvu" />
                  </div>
                  <div className="text-left" data-id="element-1615" data-mp="6lobakmtb7ac">
                    <div className="font-bold text-lg text-gray-900" data-id="element-1616" data-mp="6mqxwgd3qnkg">
                      Scan QR Code
                    </div>
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1617" data-mp="a3lrxzh5e4mz">
                      Verify permit entry/exit
                    </div>
                  </div>
                </button>

                <button onClick={() => handleScan('rfid')} className="group w-full bg-white border border-gray-100 rounded-[2rem] p-6 flex items-center gap-5 hover:border-green-200 hover:bg-green-50/30 transition-all shadow-sm active:scale-[0.98]" data-id="element-1618" data-mp="j2z1st96ov88">
                  <div className="w-16 h-16 bg-[#2E7D32] text-white rounded-2xl flex items-center justify-center shadow-lg shadow-green-700/20 group-hover:scale-110 transition-transform" data-id="element-1619" data-mp="x2rtaqsjbfh9">
                    <RadioIcon size={32} data-id="element-1620" data-mp="16stbx324c5os" />
                  </div>
                  <div className="text-left" data-id="element-1621" data-mp="16v7679oz5dva">
                    <div className="font-bold text-lg text-gray-900" data-id="element-1622" data-mp="1bsyza71cv612">
                      Scan RFID
                    </div>
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1623" data-mp="1grsd60kk0z1r">
                      Tap card to reader
                    </div>
                  </div>
                </button>

                <button onClick={() => setView('compliance')} className="group w-full bg-white border border-gray-100 rounded-[2rem] p-6 flex items-center gap-5 hover:border-amber-200 hover:bg-amber-50/30 transition-all shadow-sm active:scale-[0.98]" data-id="element-1624" data-mp="m5d2gsgoyi2d">
                  <div className="w-16 h-16 bg-amber-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-amber-600/20 group-hover:scale-110 transition-transform" data-id="element-1625" data-mp="19sbdvbpyeztf">
                    <ShieldAlertIcon size={32} data-id="element-1626" data-mp="1jqr8hoo6wr7o" />
                  </div>
                  <div className="text-left" data-id="element-1627" data-mp="1es66pktahzh4">
                    <div className="font-bold text-lg text-gray-900" data-id="element-1628" data-mp="1et8zjya6abzo">
                      Forest Compliance
                    </div>
                    <div className="text-xs text-gray-500 font-medium" data-id="element-1629" data-mp="3gk2imvjddbcf">
                      Report offenses & cases
                    </div>
                  </div>
                </button>
              </div>

              {!isOnline && <div className="bg-amber-50 border border-amber-100 rounded-2xl p-4 flex items-start gap-3" data-id="element-1630" data-mp="2103avi3ti3v2">
                  <WifiOffIcon className="text-amber-600 flex-shrink-0 mt-0.5" size={20} data-id="element-1631" data-mp="1mbp8176eifei" />
                  <div className="text-sm" data-id="element-1632" data-mp="1dbsdioxbymbj">
                    <div className="font-bold text-amber-900" data-id="element-1633" data-mp="1dar40ovyq7vx">
                      Working Offline
                    </div>
                    <div className="text-amber-700 text-xs mt-0.5" data-id="element-1634" data-mp="1hb181w072o85">
                      Data will sync when connected
                    </div>
                    <button className="mt-2 text-amber-900 text-[10px] font-black uppercase tracking-widest bg-amber-200/50 px-2 py-1 rounded-md" data-id="element-1635" data-mp="18bnvgugrxjj7">
                      3 pending syncs
                    </button>
                  </div>
                </div>}
            </div>}

          {view === 'scan' && <div className="flex flex-col items-center justify-center h-full p-6" data-id="element-1636" data-mp="1pj3x8qbearrn">
              <div className="w-full aspect-square max-w-[280px] border-2 border-green-600/30 rounded-[3rem] flex items-center justify-center mb-8 relative overflow-hidden bg-white shadow-2xl" data-id="element-1637" data-mp="1ljboodm04lma">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-green-600/10 to-transparent animate-scan-line" data-id="element-1638" data-mp="1br5v4zg3pw4z"></div>
                <div className="absolute inset-4 border-2 border-dashed border-green-600/20 rounded-[2rem]" data-id="element-1639" data-mp="16qrnvjmbqq80"></div>
                <CameraIcon size={80} className="text-green-600/20" data-id="element-1640" data-mp="xsg1xuwekglw" />
              </div>
              <div className="text-center space-y-2" data-id="element-1641" data-mp="xuam36zuo4ox">
                <div className="font-black text-2xl text-gray-900 tracking-tight" data-id="element-1642" data-mp="suo9mzruish6">
                  Scanning...
                </div>
                <p className="text-sm text-gray-500 font-medium" data-id="element-1643" data-mp="2s4e81nzf0wdk">
                  Position QR code or tap RFID card
                </p>
              </div>
            </div>}

          {view === 'result' && scanResult && <div className="p-6 space-y-6 animate-in fade-in slide-in-from-bottom-8 duration-500" data-id="element-1644" data-mp="2zpgf470k44yh">
              {/* Status Header */}
              <div className={`rounded-[2.5rem] overflow-hidden shadow-2xl shadow-gray-200 border-b-4 ${scanResult === 'valid' ? 'border-green-600 bg-white' : 'border-red-600 bg-white'}`} data-id="element-1645" data-mp="34h89ytqqwwuf">
                <div className={`px-6 py-6 flex flex-col items-center text-center gap-3 ${scanResult === 'valid' ? 'bg-green-600' : 'bg-red-600'}`} data-id="element-1646" data-mp="2bu5eybla348x">
                  <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center text-white backdrop-blur-md" data-id="element-1647" data-mp="2lonmxsxq9lyj">
                    {scanResult === 'valid' ? <CheckCircleIcon size={32} data-id="element-1648" data-mp="z7w4xyidx8w" /> : <XCircleIcon size={32} data-id="element-1649" data-mp="50tid9wxnnvr" />}
                  </div>
                  <div className="space-y-1" data-id="element-1650" data-mp="1dqt5hopnrfq3">
                    <h3 className="font-black text-2xl text-white tracking-tight uppercase" data-id="element-1651" data-mp="1dpzuucnkw62o">
                      {scanResult === 'valid' ? 'Permit Valid' : 'Access Denied'}
                    </h3>
                    <div className="bg-black/10 px-3 py-1 rounded-full text-[10px] font-bold text-white/80 uppercase tracking-widest" data-id="element-1652" data-mp="1sfpb7f48sgnj">
                      Verified at{' '}
                      {new Date().toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                    </div>
                  </div>
                </div>

                <div className="p-6 space-y-8" data-id="element-1653" data-mp="19oy4ymfjx6dd">
                  {scanResult === 'valid' ? <>
                      {/* Beneficiary Header */}
                      <div className="flex items-center gap-5" data-id="element-1654" data-mp="2l3tho2un0xra">
                        <div className="relative" data-id="element-1655" data-mp="2l20beonxsfjt">
                          <div className="w-20 h-20 bg-gray-100 rounded-[1.5rem] flex items-center justify-center text-4xl shadow-inner border-2 border-white overflow-hidden" data-id="element-1656" data-mp="9gzqyk6s6k7t">
                            👤
                          </div>
                          <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-green-500 rounded-full border-4 border-white flex items-center justify-center text-white" data-id="element-1657" data-mp="3vuhuodinjex3">
                            <CheckCircleIcon size={14} data-id="element-1658" data-mp="3lyxzxuftqm9x" />
                          </div>
                        </div>
                        <div className="space-y-1" data-id="element-1659" data-mp="3hvi24us0qfvn">
                          <h4 className="text-2xl font-black text-gray-900 leading-tight" data-id="element-1660" data-mp="3cwygywl9184c">
                            Rahim Uddin
                          </h4>
                          <div className="flex flex-wrap gap-2" data-id="element-1661" data-mp="37zy9ch8r3xb4">
                            <span className="px-2 py-0.5 bg-green-100 text-green-700 text-[10px] font-bold rounded-md uppercase tracking-wider" data-id="element-1662" data-mp="1b4sffze1dr3v">
                              Active
                            </span>
                            <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-[10px] font-bold rounded-md uppercase tracking-wider" data-id="element-1663" data-mp="30le8g2pttrns">
                              PER-2024-001
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Info Grid */}
                      <div className="grid grid-cols-2 gap-3" data-id="element-1664" data-mp="3jdq8git0cgur">
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1665" data-mp="3je8bpze37vc6">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1666" data-mp="3obs0ht8evqid">
                            <NavigationIcon size={12} data-id="element-1667" data-mp="39er8domb5tjd" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1668" data-mp="3edufdelum9tz">
                              Range
                            </span>
                          </div>
                          <div className="text-sm font-black text-gray-900" data-id="element-1669" data-mp="22yyo8t60mfwj">
                            Chandpai
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1670" data-mp="l3ewi4m3h7hp">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1671" data-mp="g4v9s1zofroa">
                            <MapPinIcon size={12} data-id="element-1672" data-mp="u05x8ubldaim" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1673" data-mp="q0exw2801m2h">
                              Station
                            </span>
                          </div>
                          <div className="text-sm font-black text-gray-900" data-id="element-1674" data-mp="3ti6p3eeba1zm">
                            Karamjal
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1675" data-mp="6cxuok5jsfka">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1676" data-mp="3es975g6z68iv">
                            <FileTextIcon size={12} data-id="element-1677" data-mp="3aqw052s5bzad" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1678" data-mp="3aq4bkbwyv1tl">
                              Type
                            </span>
                          </div>
                          <div className="text-sm font-black text-gray-900" data-id="element-1679" data-mp="3sfztfaim98sq">
                            Fishing
                          </div>
                        </div>
                        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100 space-y-1" data-id="element-1680" data-mp="6056z1t5xzpc">
                          <div className="flex items-center gap-1.5 text-gray-400" data-id="element-1681" data-mp="azhwjubf5kvm">
                            <CalendarIcon size={12} data-id="element-1682" data-mp="f01w14jgt0kx" />
                            <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-1683" data-mp="eyid166fcbfg">
                              Expiry
                            </span>
                          </div>
                          <div className="text-sm font-black text-green-600" data-id="element-1684" data-mp="oxpzqjz1tif8">
                            2024-04-05
                          </div>
                        </div>
                      </div>

                      {/* Vessel Card */}
                      <div className="bg-blue-600 rounded-[2rem] p-5 text-white shadow-xl shadow-blue-600/20 relative overflow-hidden" data-id="element-1685" data-mp="2j6v5ji1pca2w">
                        <ShipIcon size={100} className="absolute -right-8 -bottom-8 text-white/10 rotate-12" data-id="element-1686" data-mp="2eev23fmfaz1k" />
                        <div className="relative z-10 space-y-4" data-id="element-1687" data-mp="24ii6udb8cd4p">
                          <div className="flex items-center gap-2" data-id="element-1688" data-mp="324xnjcvu16r7">
                            <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm" data-id="element-1689" data-mp="3234qmpb0u0we">
                              <ShipIcon size={16} data-id="element-1690" data-mp="2s6rpj6d5ckrm" />
                            </div>
                            <h5 className="font-black text-sm uppercase tracking-wider" data-id="element-1691" data-mp="2n7yle4jr2644">
                              Vessel Details
                            </h5>
                          </div>
                          <div className="grid grid-cols-2 gap-4" data-id="element-1692" data-mp="1gpi96spbe8uj">
                            <div className="space-y-0.5" data-id="element-1693" data-mp="1br8cuerut27c">
                              <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest" data-id="element-1694" data-mp="3ssz32rmkiy8">
                                Name
                              </div>
                              <div className="text-sm font-black" data-id="element-1695" data-mp="3q0syhbghufif">
                                MV Sundarban-1
                              </div>
                            </div>
                            <div className="space-y-0.5" data-id="element-1696" data-mp="3v1gp3w0t8uc4">
                              <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest" data-id="element-1697" data-mp="3g9y23e9j9zj9">
                                BLC No
                              </div>
                              <div className="text-sm font-black" data-id="element-1698" data-mp="37b487vnl7n9e">
                                2024-8821
                              </div>
                            </div>
                            <div className="space-y-0.5" data-id="element-1699" data-mp="2xbdc5pjdp077">
                              <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest" data-id="element-1700" data-mp="2xdyhioivxy9p">
                                Type
                              </div>
                              <div className="text-sm font-black" data-id="element-1701" data-mp="2ipomouuhvy4e">Trawler</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Compliance Alert */}
                      <div className="bg-red-50 rounded-[2rem] p-5 border-2 border-red-100 space-y-4" data-id="element-1702" data-mp="2noj5hwsgpmoi">
                        <div className="flex items-center gap-3" data-id="element-1703" data-mp="31nsi6mhglynq">
                          <div className="w-12 h-12 bg-red-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-red-600/20" data-id="element-1704" data-mp="31lxy1ae0iakp">
                            <ShieldAlertIcon size={24} data-id="element-1705" data-mp="3be3qel86eu0f" />
                          </div>
                          <div className="space-y-0.5" data-id="element-1706" data-mp="36e90ol050agy">
                            <div className="text-[10px] font-black text-red-400 uppercase tracking-widest" data-id="element-1707" data-mp="36gu258wiwoe6">
                              Compliance Alert
                            </div>
                            <div className="text-sm font-black text-red-900" data-id="element-1708" data-mp="3gerp7t2ncf57">
                              Poaching (CASE-2024-002)
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between bg-white rounded-xl p-3 border border-red-100" data-id="element-1709" data-mp="2ayse396bee9w">
                          <div className="flex items-center gap-2" data-id="element-1710" data-mp="2fyerbim57uip">
                            <StatusBadge status="banned" data-id="element-1711" data-mp="2fviszt6dv3tq" />
                            <span className="text-xs font-black text-red-600 uppercase tracking-tight" data-id="element-1712" data-mp="1ibfp6scoludf">
                              Entry Denied
                            </span>
                          </div>
                          <AlertTriangleIcon size={16} className="text-red-600 animate-pulse" data-id="element-1713" data-mp="1s6zlhfv5qv2p" />
                        </div>
                      </div>
                    </> : <div className="text-center py-12 space-y-6" data-id="element-1714" data-mp="14hf1qur6jtsd">
                      <div className="relative inline-block" data-id="element-1715" data-mp="3hspz8gev7fev">
                        <div className="w-24 h-24 bg-red-50 rounded-[2rem] flex items-center justify-center mx-auto border-2 border-red-100" data-id="element-1716" data-mp="3hqvkjju6sjj8">
                          <AlertTriangleIcon size={48} className="text-red-600" data-id="element-1717" data-mp="38rrz497jrs1k" />
                        </div>
                        <div className="absolute -top-2 -right-2 w-10 h-10 bg-red-600 text-white rounded-full border-4 border-white flex items-center justify-center" data-id="element-1718" data-mp="2yunck89shuk8">
                          <XCircleIcon size={20} data-id="element-1719" data-mp="2u1kgnthji90v" />
                        </div>
                      </div>
                      <div className="space-y-2 px-4" data-id="element-1720" data-mp="2pzfsha9v24lm">
                        <h4 className="text-2xl font-black text-gray-900 tracking-tight uppercase" data-id="element-1721" data-mp="2l40bwakgxuli">
                          Permit Expired
                        </h4>
                        <p className="text-sm text-gray-500 font-medium leading-relaxed" data-id="element-1722" data-mp="2b416unn9cmde">
                          This permit expired on{' '}
                          <span className="text-red-600 font-black underline decoration-2 underline-offset-4" data-id="element-1723" data-mp="29veswjbpa26c">
                            2024-03-20
                          </span>
                          . Access to the forest area is strictly prohibited.
                        </p>
                      </div>
                      <div className="bg-gray-900 text-white rounded-2xl p-4 text-xs font-bold uppercase tracking-widest leading-relaxed mx-4" data-id="element-1724" data-mp="1vyhvu04znoh0">
                        Action: Escort to station office immediately
                      </div>
                    </div>}
                </div>
              </div>

              <button onClick={() => {
            setView('home');
            setScanResult(null);
          }} className="w-full py-5 bg-gray-900 text-white rounded-[2rem] font-black text-lg shadow-2xl shadow-gray-900/20 hover:bg-black transition-all active:scale-[0.98] uppercase tracking-widest" data-id="element-1725" data-mp="1c8pltv254zdm">
                Finish Verification
              </button>
            </div>}

          {view === 'compliance' && <div className="p-6 space-y-6" data-id="element-1726" data-mp="3nvrmoxuqk44l">
              <div className="flex items-center justify-between" data-id="element-1727" data-mp="3nx2quys3fdw8">
                <div className="space-y-1" data-id="element-1728" data-mp="3sve31g5v20hm">
                  <h2 className="text-2xl font-black text-gray-900 leading-tight" data-id="element-1729" data-mp="3such2gnb3tl4">
                    Compliance
                  </h2>
                  <p className="text-sm text-gray-500" data-id="element-1730" data-mp="3066urpgltwj6">Manage field offenses</p>
                </div>
                <button onClick={() => setView('report-case')} className="bg-[#1B5E20] text-white w-14 h-14 rounded-2xl shadow-xl shadow-green-900/20 flex items-center justify-center active:scale-95 transition-transform" data-id="element-1731" data-mp="3559wp11afmmx">
                  <PlusIcon size={28} data-id="element-1732" data-mp="2cejk8i3ngy32" />
                </button>
              </div>

              <div className="space-y-4" data-id="element-1733" data-mp="2hdw732uiu55n">
                <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]" data-id="element-1734" data-mp="3kqd252l7907x">
                  Recent Cases
                </h3>
                <div className="grid gap-3" data-id="element-1735" data-mp="3fr0dccarpj2p">
                  {recentCases.map(c => <div key={c.id} className="bg-white border border-gray-100 rounded-[1.5rem] p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-1736" data-mp="3thn49iaae4o8">
                      <div className="flex justify-between items-start mb-3" data-id="element-1737" data-mp="31s0q992wlc8n">
                        <div className="space-y-0.5" data-id="element-1738" data-mp="2wtz76o5h9cx6">
                          <div className="font-black text-gray-900" data-id="element-1739" data-mp="3asfdidzfh1es">{c.id}</div>
                          <div className="text-xs text-gray-500 font-bold" data-id="element-1740" data-mp="3aqcg38vy4601">
                            {c.type}
                          </div>
                        </div>
                        <StatusBadge status={c.status as any} data-id="element-1741" data-mp="q0my4mzy4434" />
                      </div>
                      <div className="text-[10px] text-gray-400 font-bold flex items-center gap-1.5 uppercase tracking-wider" data-id="element-1742" data-mp="l2bqmix4i5o2">
                        <CalendarIcon size={10} data-id="element-1743" data-mp="tm8cld6rea0a" />
                        Filed on {c.date}
                      </div>
                    </div>)}
                </div>
              </div>

              <div className="bg-amber-600 rounded-[2rem] p-6 text-white shadow-xl shadow-amber-600/20 relative overflow-hidden" data-id="element-1744" data-mp="joanyokzmb75">
                <ShieldAlertIcon size={100} className="absolute -right-8 -bottom-8 text-white/10 rotate-12" data-id="element-1745" data-mp="1ca3ikaw4qjiu" />
                <div className="relative z-10 space-y-2" data-id="element-1746" data-mp="1hbst7pffwv6e">
                  <div className="flex items-center gap-2 font-black text-sm uppercase tracking-widest" data-id="element-1747" data-mp="12jsfsro6mgdj">
                    <AlertTriangleIcon size={18} data-id="element-1748" data-mp="17ils4grqg1c4" />
                    Field Protocol
                  </div>
                  <p className="text-xs text-white/80 font-medium leading-relaxed" data-id="element-1749" data-mp="1v7wm9fekuxha">
                    Always ensure your safety before reporting an offense. Use
                    the "Report Case" button to capture evidence and location.
                  </p>
                </div>
              </div>
            </div>}

          {view === 'report-case' && <div className="p-6 space-y-8" data-id="element-1750" data-mp="2cx1kurfen6d">
              <div className="flex items-center gap-4" data-id="element-1751" data-mp="2fsxkdjpr1s6">
                <button onClick={() => setView('compliance')} className="w-12 h-12 bg-white border border-gray-100 rounded-2xl flex items-center justify-center text-gray-400 active:scale-95 transition-transform shadow-sm" data-id="element-1752" data-mp="3tl1eqlptj0d3">
                  <XCircleIcon size={24} data-id="element-1753" data-mp="lcaurahbztvt" />
                </button>
                <h2 className="text-2xl font-black text-gray-900 tracking-tight" data-id="element-1754" data-mp="lahnpu2t37na">
                  Report Offense
                </h2>
              </div>

              <div className="space-y-6" data-id="element-1755" data-mp="1dtx0i98a409d">
                <div className="space-y-2" data-id="element-1756" data-mp="1duyasbhh0iq1">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1757" data-mp="191vg200yj389">
                    Offender Name
                  </label>
                  <input type="text" placeholder="Enter name or 'Unknown'" className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl focus:ring-4 focus:ring-green-600/5 focus:border-green-600 outline-none transition-all font-bold text-gray-900 placeholder:text-gray-300 shadow-sm" value={complianceForm.offenderName} onChange={e => setComplianceForm({
                ...complianceForm,
                offenderName: e.target.value
              })} data-id="element-1758" data-mp="1lceeosr3o38o" />
                </div>

                <div className="space-y-2" data-id="element-1759" data-mp="2e0ac5zohtz6i">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1760" data-mp="2j0ohh9ypmv0u">
                    Offense Type
                  </label>
                  <select className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl focus:ring-4 focus:ring-green-600/5 focus:border-green-600 outline-none transition-all font-bold text-gray-900 shadow-sm appearance-none" value={complianceForm.offenseType} onChange={e => setComplianceForm({
                ...complianceForm,
                offenseType: e.target.value
              })} data-id="element-1761" data-mp="2mzdswx06u2hu">
                    <option value="" data-id="element-1762" data-mp="11nbst0p72anz">Select Offense</option>
                    <option value="Illegal Entry" data-id="element-1763" data-mp="1fo5znewlg3kj">Illegal Entry</option>
                    <option value="Poaching" data-id="element-1764" data-mp="1fnd1317sgkdh">Poaching</option>
                    <option value="Overharvesting" data-id="element-1765" data-mp="1bnm4uhzhtc1k">Overharvesting</option>
                    <option value="Unauthorized Vessel" data-id="element-1766" data-mp="3hf9bu8m4tq77">
                      Unauthorized Vessel
                    </option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-1767" data-mp="3dgadx7ytitp9">
                  <div className="space-y-2" data-id="element-1768" data-mp="33baeyujyci5u">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1769" data-mp="37bkvh15deqyy">
                      Latitude
                    </label>
                    <div className="relative" data-id="element-1770" data-mp="2tjo4j0ffun45">
                      <input type="text" readOnly className="w-full pl-10 pr-4 py-4 bg-gray-100 border-transparent rounded-2xl font-bold text-gray-500 text-sm" value={complianceForm.latitude} data-id="element-1771" data-mp="2yj0ptgqnvm4m" />
                      <MapPinIcon size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1772" data-mp="2am3gtwoetul4" />
                    </div>
                  </div>
                  <div className="space-y-2" data-id="element-1773" data-mp="8ui1dmdskth1">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1774" data-mp="dsrwjwzinu2n">
                      Longitude
                    </label>
                    <div className="relative" data-id="element-1775" data-mp="1mflb459k7f05">
                      <input type="text" readOnly className="w-full pl-10 pr-4 py-4 bg-gray-100 border-transparent rounded-2xl font-bold text-gray-500 text-sm" value={complianceForm.longitude} data-id="element-1776" data-mp="1hdw18sy2p7dn" />
                      <MapPinIcon size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1777" data-mp="13o0u80isgv2k" />
                    </div>
                  </div>
                </div>

                <div className="space-y-2" data-id="element-1778" data-mp="tqmpgy689uq3">
                  <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1" data-id="element-1779" data-mp="po9nmkulqgyl">
                    Description
                  </label>
                  <textarea rows={4} placeholder="Describe the situation..." className="w-full px-5 py-4 bg-white border border-gray-100 rounded-2xl focus:ring-4 focus:ring-green-600/5 focus:border-green-600 outline-none transition-all font-bold text-gray-900 placeholder:text-gray-300 shadow-sm resize-none" value={complianceForm.description} onChange={e => setComplianceForm({
                ...complianceForm,
                description: e.target.value
              })} data-id="element-1780" data-mp="2k1956jijll8i"></textarea>
                </div>

                <button onClick={handleReportCase} disabled={!complianceForm.offenseType} className="w-full py-5 bg-red-600 text-white rounded-[2rem] font-black text-lg shadow-xl shadow-red-600/20 hover:bg-red-700 transition-all active:scale-[0.98] uppercase tracking-widest disabled:opacity-50 disabled:shadow-none" data-id="element-1781" data-mp="3s0oexyrb1f27">
                  Submit Field Report
                </button>
              </div>
            </div>}
        </div>

        {/* Bottom Navigation */}
        <div className="border-t border-gray-100 px-8 py-6 bg-white flex-shrink-0" data-id="element-1782" data-mp="2894yi33ltgtb">
          <div className="flex justify-around items-center" data-id="element-1783" data-mp="1tkij61dz8p23">
            <button onClick={() => setView('home')} className={`flex flex-col items-center gap-1.5 transition-all ${view === 'home' || view === 'scan' || view === 'result' ? 'text-green-600 scale-110' : 'text-gray-300 hover:text-gray-400'}`} data-id="element-1784" data-mp="1ykmznrevxjsb">
              <div className={`p-2 rounded-xl ${view === 'home' || view === 'scan' || view === 'result' ? 'bg-green-50' : ''}`} data-id="element-1785" data-mp="1ok48scowl30w">
                <CameraIcon size={24} strokeWidth={view === 'home' || view === 'scan' || view === 'result' ? 3 : 2} data-id="element-1786" data-mp="1fmk56x3kiun4" />
              </div>
              <span className="text-[9px] font-black uppercase tracking-[0.15em]" data-id="element-1787" data-mp="ybx3bg1j2wef">
                Scan
              </span>
            </button>
            <button onClick={() => setView('compliance')} className={`flex flex-col items-center gap-1.5 transition-all ${view === 'compliance' || view === 'report-case' ? 'text-amber-600 scale-110' : 'text-gray-300 hover:text-gray-400'}`} data-id="element-1788" data-mp="tf6oew1gm6ul">
              <div className={`p-2 rounded-xl ${view === 'compliance' || view === 'report-case' ? 'bg-amber-50' : ''}`} data-id="element-1789" data-mp="1h1mtfpuciu00">
                <ShieldAlertIcon size={24} strokeWidth={view === 'compliance' || view === 'report-case' ? 3 : 2} data-id="element-1790" data-mp="1r0u8chgqawp8" />
              </div>
              <span className="text-[9px] font-black uppercase tracking-[0.15em]" data-id="element-1791" data-mp="3srp97npslm2t">
                Cases
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>;
}